import { styled, Card } from '@bluedolphin/ui';

export const CustomCard = styled(Card)(({ theme }) => ({
    display: 'flex',
    width: '480px',
    flexDirection: 'column',
    justifyContent: 'space-between',
    alignItems: 'center',
    flexShrink: 0,
    borderBottom: '4px solid',
    background: theme.palette.common.white,
    padding: theme.spacing(4),
}));
